import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {SidemenuService} from "../@fuse/services/sidemenu/sidemenu.service";
import {HelperService} from "./core/services/helper/helper.service";
import {CommonConstants} from "./core/constants/common-constants";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    currentRoute: any;
    isPartner: boolean = false;
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _sideMenuService: SidemenuService,
        private _helper: HelperService,
        private _route: ActivatedRoute,

    ) {
        this.isPartner = this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1;
        if(this._router.url.indexOf('/partner-management') !== -1){
            this.isPartner = false;
        } 
        this.getUserData()
    }

    getUserData(){
        this._router.events.subscribe((event: any)=> {
            if (event instanceof NavigationEnd) {
                this.currentRoute = event.url;
                this._helper._getUrl.next(this.currentRoute)
                const admin = this._helper.getLocalStorageData(CommonConstants.ADMIN_CHECK_URL);
                const client = this._helper.getLocalStorageData(CommonConstants.CLIENT_CHECK_URL);
                const subAdmin = this._helper.getLocalStorageData(CommonConstants.SUB_ADMIN_CHECK_URL);
                let data = {};
                const permissions = ['canAdd', 'canDelete', 'canEdit', 'canRead'];
                if ((this._router.url.indexOf('/partner') == -1 && window.location.origin.indexOf('partners') == -1) || this._router.url.indexOf('/partner-management') != -1){
                    data = {ADMIN : permissions}
                }  else {
                    data = {PARTNER : permissions}
                }

                this._sideMenuService.load(data)
            }
        })
    }
}
